<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">网关绑定</h1>
			<div>
				<span>时间段选择：</span>
				<el-date-picker
			      v-model="starttime"
			      type="date"
			      value-format="yyyy-MM-dd"
			      placeholder="开始日期">
			    </el-date-picker>
			    <el-date-picker
			      v-model="endtime"
			      type="date"
			      value-format="yyyy-MM-dd"
			      placeholder="结束日期">
			    </el-date-picker>
			    <el-button @click="getDeviceList(1)"> 查 看 </el-button>
			</div>
			<div class="search-box search-box2">
		  		<!--<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>-->
				<input placeholder="请输入要搜索的mac地址" v-model="mac_address" @keyup.enter="getDeviceList()" class="log-input search-input" />
				<el-button @click="getDeviceList()"> 搜 索 </el-button>
			</div>
			<br />
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="deviceList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			      prop="device_name"
			      label="设备名称"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="device_type"
			      label="设备类型"
			      :formatter="deviceTypeFormat"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="mac_address"
			      label="MAC地址"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="equipment_staus"
			      label="运行状态"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="created_time"
			      label="创建时间"
			      :formatter="dateFormat">
			    </el-table-column>
			    <el-table-column
			      prop="updated_time"
			      label="更新时间"
			      :formatter="dateFormat">
			    </el-table-column>
			    <el-table-column
		          label="操作">
		          <template slot-scope="scope">
		            <el-button type="text" size="small"
		                       @click="clickBindAdmin(scope.$index, scope.row)">绑定管理员
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
			<br />
			<div class="text-right">
				<el-pagination
					@current-change="handleCurrentChange"
				  :page-size="pagesize"
				  layout="total, prev, pager, next"
				  :total="totalNum">
				</el-pagination>
			</div>
		</div>
		<!--绑定用户-->
		<el-dialog title="绑定管理员" :visible.sync="bindAdminFlag" width="500px">
        
	        <el-form>
	        	<el-form-item label="设备MAC" :label-width="formLabelWidth">
			    	<span v-text="bindDevice.mac_address"></span>
			    </el-form-item>
	          <el-form-item :model="adminPhone" label="管理员手机号" :label-width="formLabelWidth" prop="area">
	            <el-input v-model="adminPhone" auto-complete="off"></el-input>
	          </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="bindAdminFlag=false">取 消</el-button>
	          <el-button type="primary" @click="bindAdmin()">绑 定</el-button>
	        </div>
	    </el-dialog>
	    <loading v-if="showLoading"></loading>
	</div>  
</template>

<script>
	export default {
		mounted() {
			this.$nextTick(function(){
				
				this.getDeviceList();
		  	})
    	},
    	data(){
    		return{
    			deviceList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			bindAdminFlag:false,
    			formLabelWidth:'110px',
    			adminPhone:"",
    			bindDevice:"",
    			endtime:new Date(),
       			starttime:new Date(),
       			mac_address:"",
       			showLoading:false
    		}
    	},
    	methods:{
    		getDeviceList(num){
    			this.showLoading = true;
    			if(num){
    				this.mac_address = "";
    			}else{
    				this.starttime="";
    				this.endtime="";
    			}
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
			  		timestamp:Date.parse( new Date()),
			  		starttime:Date.parse(this.starttime)/1000 || "",
			  		endtime:Date.parse(this.endtime)/1000 || "",
			  		mac_address:this.mac_address,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Terminal/DeviceList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.deviceList = res.data.data.datalist;
		        		this.totalNum = res.data.data.totalNumber;
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		
		  		
			},
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},
//			点击绑定用户按钮
			clickBindAdmin(index,row){
				this.bindAdminFlag = true;
				this.bindDevice = row;
			},
//			绑定管理员
			bindAdmin(){
				this.bindAdminFlag = false;
				this.showLoading = true;
				let valiCodeParams={
					uid: this.getCookie('uid'),
					device_id: this.bindDevice.id,
					phonenumber: this.adminPhone,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Terminal/DeviceDind",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
    	}
   }
</script>

<style>
	.search-box2{margin-top: -69px;}
</style>


// WEBPACK FOOTER //
// src/components/device/bindDevice.vue